import React, {FC, useState} from "react";
import {Paragraph} from "../../../lib/src/components/Paragraph";
import { Input } from "@jane/lib/src/components/form/Input";
import {ModalFooter, useModalControls} from "@jane/lib/src/components/layout/ModalProvider";

export const ForwardCallModal: FC<{onConfirmed: (target: string) => void}> = (props) => {
  const [target,setTarget] = useState('')
  const {close} = useModalControls()
  return <div className={"flex flex-col space-y-3"}>
    <Paragraph>Je staat op het punt om een gesprek door te sturen. Vul hieronder de extensie van de collega in waarnaar je het gesprek wilt doorsturen</Paragraph>
    <Input type={'text'} label={'Extensie'} value={target} onChange={(value) => {
      if (value.length > 4) {
        return
      }
      if (! /^[0-9]{0,4}$/.test(value)) {
        return;
      }
      setTarget(value)
    }} placeholder={'000'} />
    <ModalFooter text={'Doorsturen'} onSubmit={() => {
      props.onConfirmed(target);
      close();
    }} />
  </div>
}